export default __webpack_public_path__ + "static/media/comeet.3f262115.png";